export default __webpack_public_path__ + "TTHoves-Medium.woff2";